import angular from 'angular';
import moment from 'moment';

angular.module('principal');

class principalCtrl {
    /* @ngInject */
    constructor(
        $state,
        $translate,
        uiGridExporterConstants,
        AuthSvc,
        i18nService,
        DoSvc,
        PrincipalService,
        PrincipalSvc,
        DematPlatformService,
        uiGridConstants,
        $uibModal
    ) {
        this.$state = $state;
        this.$translate = $translate;
        this.uiGridExporterConstants = uiGridExporterConstants;
        this.AuthSvc = AuthSvc;
        this.i18nService = i18nService;
        this.PrincipalSvc = PrincipalSvc;
        this.DoSvc = DoSvc;
        this.PrincipalService = PrincipalService;
        this.DematPlatformService = DematPlatformService;
        this.uiGridConstants = uiGridConstants;
        this.$uibModal = $uibModal;
    }

    $onInit() {
        this.i18nService.setCurrentLang(this.$translate.use());
        // Accès raccourcis aux autorisations depuis le scope principal
        this.isAuthorized = this.AuthSvc.isAuthorized;

        this.DematPlatformService.query(data => {
            this.dematPlatforms = data;
        });

        this.isActive = [{ active: true }, { active: false }, { active: false }];

        this.criteriaP = {
            principalId: [],
            principalEid: [],
            principalName: [],
            country: [],
            dematPlatform: [],
            profilBuyerOrSeller: true,
        };

        this.PrincipalSvc.listPrincipals().then(data => {
            this.principals = data;
        });

        this.isOpenSearchPanel = true;

        this.getPrincipalSearchFilter();

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.principal.consult.detail({ id : row.entity.principalId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        var translatedCountryCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.principal.consult.detail({ id : row.entity.principalId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{\'country.\' + COL_FIELD.toLowerCase() | translate}}</div></a>';
        var companyCellTemplate =
            '<div class="ui-grid-cell-contents ui-grid-cursor-pointer"><span style="color: blue; cursor: pointer;" ng-click="grid.appScope.$ctrl.goToCompany(row)"><u>{{COL_FIELD}}</u></span></div>';
        var containerCellTemplate =
            '<div class="ui-grid-cell-contents ui-grid-cursor-pointer"><span style="color: blue; cursor: pointer;" ng-click="grid.appScope.$ctrl.goToContainer(row)"><u>{{COL_FIELD}}</u></span></div>';

        this.principalGridOptions = {
            columnDefs: [
                {
                    name: 'eidWithId',
                    displayName: 'principal.principal.column.principal.id',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'principalName',
                    displayName: 'principal.principal.column.name',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    sort: { direction: this.uiGridConstants.ASC, priority: 0 },
                },
                {
                    name: 'country',
                    displayName: 'principal.principal.column.country',
                    cellTemplate: translatedCountryCellTemplate,
                    headerCellFilter: 'translate',
                    sortingAlgorithm: (a, b /*, rowA, rowB, direction*/) => {
                        return this.sortingCountries(a, b);
                    },
                },
                {
                    name: 'nbLegalEntities',
                    displayName: 'principal.principal.column.companies',
                    cellTemplate: companyCellTemplate,
                    headerCellFilter: 'translate',
                    enableSorting: false,
                },
                {
                    name: 'containers',
                    displayName: 'principal.principal.column.containers',
                    cellTemplate: containerCellTemplate,
                    headerCellFilter: 'translate',
                    enableSorting: false,
                },
                {
                    name: 'dematPlatform',
                    displayName: 'principal.principal.column.dematPlatform',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
            ],
            enableGridMenu: false,
            enableVerticalScrollbar: false,
            enableSorting: true,
            enableRowSelection: true,
            enableSelectAll: true,
            selectionRowHeaderWidth: 30,
            exporterMenuCsv: false,
            exporterMenuPdf: false,
            exporterCsvColumnSeparator: ';',
            exporterOlderExcelCompatibility: true,
            exporterHeaderFilter: this.$translate.instant,
            exporterFieldCallback: (grid, row, col, value) => {
                if (col.name === 'country') {
                    value = this.$translate.instant(value);
                }
                return value;
            },
            enableColumnMenus: false,
            rowHeight: 30,
            paginationPageSizes: [20, 50, 100],
            gridMenuTitleFilter: this.$translate,
            onRegisterApi: gridApi => {
                this.gridPrincipalApi = gridApi;
            },
        };
    }

    addNewPrincipal() {
        this.$state.go('principal_detail', { principalId: '00', mode: 'new' });
    }

    clear() {
        this.initPrincipalSearchFilter();
        this.PrincipalSvc.setPrincipalListFilter(this.criteriaP);
        this.criteriaP.country = this.criteriaP.selectedCountry ? this.criteriaP.selectedCountry.code : null;
        this.principalGridOptions.data = this.PrincipalService.getPrincipals(
            this.getPreparedCriteriaForserver(),
            data => {
                this.updatePrincipalCells(data);
            }
        );
    }

    searchPrincipal() {
        this.PrincipalSvc.setPrincipalListFilter(this.criteriaP);
        this.criteriaP.country = this.criteriaP.selectedCountry ? this.criteriaP.selectedCountry.code : null;
        this.principalGridOptions.data = this.PrincipalService.getPrincipals(
            this.getPreparedCriteriaForserver(),
            data => {
                this.updatePrincipalCells(data);
            }
        );
        this.principalPromise = this.principalGridOptions.data.$promise;
    }

    sortingCountries(a, b) {
        var countryTransA = this.$translate.instant(a);
        var countryTransB = this.$translate.instant(b);

        return countryTransA.localeCompare(countryTransB);
    }

    //exporter le tableau
    exportCsv() {
        this.principalGridOptions.exporterCsvFilename = 'epdf_' + moment().format('DDMMYYYY') + '_dataDO.csv';
        this.principalGridOptions.exporterHeaderFilter = this.$translate.instant;
        this.gridPrincipalApi.exporter.csvExport(this.uiGridExporterConstants.ALL, this.uiGridExporterConstants.ALL);
    }

    updatePrincipalCells(data) {
        this.countCompanyContainerCriteria = [];
        angular.forEach(data, (value /*, key*/) => {
            this.countCompanyContainerCriteria.push(value.principalId);
        });
        this.countedCC = this.PrincipalService.countCompanyContainer(this.countCompanyContainerCriteria, (/*data*/) => {
            for (var i = 0; i < this.principalGridOptions.data.length; i++) {
                for (var j = 0; j < this.countedCC.length; j++) {
                    if (this.countedCC[j].principalId == this.principalGridOptions.data[i].principalId) {
                        this.principalGridOptions.data[i].containers = this.countedCC[j].nbContainer;
                        break;
                    }
                }
            }
        });
    }

    initPrincipalSearchFilter() {
        this.criteriaP.dematPlatform = undefined;
        this.criteriaP.principalId = undefined;
        this.criteriaP.principalEid = undefined;
        this.criteriaP.principalName = undefined;
        this.criteriaP.country = undefined;
        this.criteriaP.selectedCountry = undefined;
    }

    getPrincipalSearchFilter() {
        if (this.PrincipalSvc.getPrincipalListFilter()) this.criteriaP = this.PrincipalSvc.getPrincipalListFilter();
        else this.initPrincipalSearchFilter();
    }

    getTableHeight(gridApi) {
        var rowHeight = 30;
        var headerHeight = 30;
        var scrollHeight = 20;
        var footerHeight = 32;
        return {
            height:
                gridApi.core.getVisibleRows(gridApi.grid).length * rowHeight +
                headerHeight +
                scrollHeight +
                footerHeight +
                'px',
        };
    }

    /**
     * Prepare le critère de recherche avant de les envoyer au serveur.
     */
    getPreparedCriteriaForserver() {
        var criteria = angular.copy(this.criteriaP);
        delete criteria.selectedCountry;
        return criteria;
    }

    goToCompany(row) {
        this.DoSvc.goToCompany(row);
    }

    goToContainer(row) {
        this.DoSvc.goToContainer(row);
    }

    openImport() {
        this.$uibModal
            .open({
                component: 'modalCheckImportPrincipal',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                () => {
                    // window.location.reload();
                },
                () => {}
            );
    }
}

angular.module('principal').component('principal', {
    templateUrl: require('./principal.html'),
    controller: principalCtrl,
    bindings: {},
});
